/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Jinhyoung Jang (jangjh@rsupport.com)
 *
 * @description
 *
 * @created at 2024-09-20 20:16:59
 **/

/* eslint-disable no-undef */
import { EventHandler } from "@rfice/eventhandler";
//*
import SoundMeter from "./sound_meter";
// import { Properties } from "@/frameworks/libraries";
/*/
import { SoundMeter } from "@rfice/xms";
//*/

class XmsUtilsStatic {
	public getVideoResolution(res: number) {
		let width = 1920;
		let height = 1080;
		if (res <= 270) {
			width = 480;
			height = 270;
		} else if (res <= 360) {
			width = 640;
			height = 360;
		} else if (res <= 450) {
			width = 800;
			height = 450;
		} else if (res <= 540) {
			width = 960;
			height = 540;
		} else if (res <= 720) {
			width = 1280;
			height = 720;
		}
		return { width, height };
	}

	public createVideoElement(
		stream: MediaStream,
		id: string,
		actorId: string,
		soundMeter: SoundMeter | null = null,
		isLocalUser = false
	) {
		// let rootEl = document.getElementById(`m-${Properties.finger_print}`) as HTMLDivElement;
		// if (!rootEl) {
		// 	rootEl = document.createElement("div");
		// 	rootEl.id = `m-${Properties.finger_print}`;
		// 	document.body.appendChild(rootEl);
		// }
		// rootEl.getElementsByClassName("video");
		const videoElement = document.createElement("video");
		videoElement.id = id;
		// @ts-ignore
		videoElement.name = actorId;
		videoElement.srcObject = stream;
		if (isLocalUser) {
			videoElement.muted = true;
		}
		// @ts-ignore
		videoElement.soundMeter = soundMeter;
		videoElement.style.width = "1280px";
		videoElement.style.height = "720px";
		videoElement.onloadeddata = async () => {
			const promise = videoElement.play();
			await promise;
			EventHandler.fire("$Unity::UserGesture$", videoElement);
		};
		// rootEl.appendChild(videoElement);
		return videoElement;
	}
}
const XmsUtils = Object.freeze(new XmsUtilsStatic());
export default XmsUtils;
